import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import { component as absorption_5_shape_rectangular } from "./components/absorption-5-shape-rectangular";
import { component as absorption_30_shape_rectangular } from "./components/absorption-30-shape-rectangular";
import { component as absorption_70_shape_rectangular } from "./components/absorption-70-shape-rectangular";

import { component as absorption_5_shape_straight } from "./components/absorption-5-shape-straight";
import { component as absorption_30_shape_straight } from "./components/absorption-30-shape-straight";
import { component as absorption_70_shape_straight } from "./components/absorption-70-shape-straight";

import { component as absorption_5_shape_ushaped } from "./components/absorption-5-shape-ushaped";
import { component as absorption_30_shape_ushaped } from "./components/absorption-30-shape-ushaped";
import { component as absorption_70_shape_ushaped } from "./components/absorption-70-shape-ushaped";

import { component as absorption_5_shape_semi_circular } from "./components/absorption-5-shape-semi-circular";
import { component as absorption_30_shape_semi_circular } from "./components/absorption-30-shape-semi-circular";
import { component as absorption_70_shape_semi_circular } from "./components/absorption-70-shape-semi-circular";

const principle: Slide = {
  description: "Please select one of each variable to obtain a simulation result of the SPL in the room.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          items: [{ name: "5%" }, { name: "30%" }, { name: "70% ceiling, 5% rest" }],
          options: {
            labelPosition: "left",
            label: "Absorption coefficient",
          },
        },
        {
          type: "dropdown",
          items: [
            { name: "rectangular" },
            { name: "straight corridor" },
            { name: "u-shaped room" },
            { name: "semi-circular corridor" },
          ],
          options: {
            labelPosition: "left",
            label: "Shape of the room",
          },
        },
      ],
      extraContent: [[], [], []],
      components: [
        [
          absorption_5_shape_rectangular,
          absorption_5_shape_straight,
          absorption_5_shape_ushaped,
          absorption_5_shape_semi_circular,
        ],
        [
          absorption_30_shape_rectangular,
          absorption_30_shape_straight,
          absorption_30_shape_ushaped,
          absorption_30_shape_semi_circular,
        ],
        [
          absorption_70_shape_rectangular,
          absorption_70_shape_straight,
          absorption_70_shape_ushaped,
          absorption_70_shape_semi_circular,
        ],
      ],
    },
  },
};

export default principle;
